import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/fold5/img04.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#654297" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Your Technology Partner for Custom Software Development in Dallas
            </h2>
            <p>
              With the aid of digital enablement provided by our software
              development competencies, businesses and startups have a wealth of
              chances to grow and expand sustainably. As the leading technology
              company for custom software development in Dallas, TekRevol is
              well-versed and suited to all your technological needs.
            </p>
            <p>
              Along with offering specialized technology solutions with a
              proactive approach to flaws and limitations, we work as a
              technology partner to help our clients improve their technical
              capabilities.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#654297",
                border: "1px solid #654297",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
